<template>
  <div class="storeManagement"
       v-loading.fullscreen.lock="fullscreenLoading">
    <div class="storeManagement_top">
      <div class="add_warehouse">
        <el-button type="success"
                   @click='show_add_warehouse()'>
          <i class="el-icon-plus"></i>
          添加仓库
        </el-button>
      </div>
    </div>
    <div class="storeManagement_main">
      <el-table :data="tableData"
                height="100%"
                style="width: 100%">
        <el-table-column prop="id"
                         label="仓库 ID"
                         width="100">
        </el-table-column>
        <el-table-column prop="name"
                         label="仓库名"
                         width="180">
        </el-table-column>
        <el-table-column prop="username"
                         label=" 联系人"
                         width="150">
        </el-table-column>
        <el-table-column prop="mobile"
                         label="联系电话"
                         width="150">
        </el-table-column>
        <el-table-column label="仓库地址">
          <template slot-scope="scope">
            <el-tooltip effect="dark"
                        placement="top">
              <div slot="content"> {{ `${scope.row.province}  ${scope.row.city}  ${scope.row.address}`}}</div>
              <div class="particulars">
                {{ `${scope.row.province}  ${scope.row.city}  ${scope.row.address}`}}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="350">
          <template slot-scope="scope">
            <div class="table_btn">
              <el-button type="primary"
                         style="margin-right:10px"
                         @click='editWarehouse(scope.row)'>编辑信息</el-button>
              <el-button type="danger"
                         slot="reference"
                         @click='show_is_remove(scope.row)'>删除仓库</el-button>
              <el-button type="info"
                         slot="reference"
                         @click="is_freight_space(scope.row)">仓位管理</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="is_edit?'编辑信息':'添加仓库'"
               @closed='restore_data'
               class="add_warehouse_dialog"
               :visible.sync="addWarehouseShow"
               width="40%">
      <el-form ref="form"
               class="add_warehouse_form"
               :model="newWarehouseShowData"
               label-width="80px">
        <el-form-item label="仓库名："
                      label-width='150px'
                      prop="name"
                      :rules="[
      { required: true, message: '仓库名称不能为空'},
      { min: 2,max:15, message: '仓库名称2-15个字符'}
    ]">
          <el-input v-model="newWarehouseShowData.name"
                    autocomplete="off"
                    placeholder="请输入新仓库的名称"></el-input>
        </el-form-item>

        <el-form-item label="仓库联系人姓名："
                      label-width='150px'
                      prop="username"
                      :rules="[
      { required: true, message: '仓库联系人不能为空'},
      {max:15, message: '联系人姓名最多15个字符'}
    ]">
          <el-input v-model="newWarehouseShowData.username"
                    autocomplete="off"
                    placeholder="请输入仓库联系人姓名"></el-input>
        </el-form-item>

        <el-form-item label="仓库联系电话："
                      label-width='150px'
                      prop="mobile"
                      :rules="[
      { required: true, message: '仓库联系电话不能为空'},
       { max: 20, message: '电话最多20个数字'}
    ]">
          <el-input type="number"
                    v-model="newWarehouseShowData.mobile"
                    autocomplete="off"
                    placeholder="请输入仓库联系人电话"></el-input>
        </el-form-item>

        <el-form-item label="地址数据："
                      label-width='150px'
                      prop="addaddress"
                      :rules="[
      { required: true, message: '地址数据不能为空',trigger: 'change' }
    ]">
          <el-cascader v-model="newWarehouseShowData.addaddress"
                       :options="allSite"
                       placeholder="请选择仓库所在国家地址"></el-cascader>
        </el-form-item>

        <el-form-item label="详细地址："
                      label-width='150px'
                      prop="address"
                      :rules="[
      { required: true, message: '详细地址不能为空'},
       { min:5,max: 50, message: '详细地址最少5个字符,最多50个字符'}
    ]">
          <el-input v-model="newWarehouseShowData.address"
                    autocomplete="off"
                    placeholder="请输入新仓库的详细地址"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button style="margin-right:10px"
                   @click="addWarehouseShow = false">取 消</el-button>

        <el-popover placement="top"
                    width="160"
                    v-model="isAddWarehouseShow">
          <p>确定要创建仓库了吗</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini"
                       type="text"
                       @click="isAddWarehouseShow = false">取消</el-button>
            <el-button type="primary"
                       size="mini"
                       @click="submitForm('form')">确定</el-button>
          </div>
          <el-button type="primary"
                     slot="reference">确 定</el-button>
        </el-popover>

      </span>
    </el-dialog>
  </div>
</template>

<script>
import common from '@/assets/js/common'
import { apiWarehouse, apiWarehouseOperation, apiZHCN, apiRemoveWarehouse } from '@/request/api'
export default {
  name: 'storeManagement',
  data () {
    return {
      // 加载----------------------
      fullscreenLoading: true,
      //当前为添加订单还是编辑---
      is_edit: false,
      // 是否显示确定删除地址-----
      isRemoveWarehouseShow: false,
      // 是否显示确定添加地址-----
      isAddWarehouseShow: false,
      //是否显示添加订单-----------
      addWarehouseShow: false,
      //表格数据--------------------
      tableData: [],
      // 联动地址-------------------
      allSite: [],
      // 仓库数据--------------------
      newWarehouseShowData: {
        name: '', //仓库名
        username: '',//仓库联系人姓名
        mobile: '', //仓库联系电话
        addaddress: [], //地址数据
        address: '',//详细地址
        info: '暂无',//仓库介绍
        issm: 0,//是否支持上门收货
        smkm: 0,//上面收货距离km
        lng: 0,//坐标lng
        lat: 0,//坐标lat
      }
    }
  },
  methods: {
    // ------------是否进入仓位界面--
    is_freight_space (row) {
      this.$confirm(`是否进入仓位管理界面`, '进入仓位管理', {
        confirmButtonText: '进 入',
        cancelButtonText: '取 消',
        type: 'success '
      }).then(() => {
        this.$router.replace({
          name: 'FreightSpace',
          query: {
            id: row.id
          }
        })
      }).catch(() => {

      });
    },
    // ------------还原默认数据-------
    restore_data () {
      this.is_edit = false
      this.newWarehouseShowData = {
        name: '', //仓库名
        username: '',//仓库联系人姓名
        mobile: '', //仓库联系电话
        addaddress: [], //地址数据
        address: '',//详细地址
        info: '暂无',//仓库介绍
        issm: 0,//是否支持上门收货
        smkm: 0,//上面收货距离km
        lng: 0,//坐标lng
        lat: 0,//坐标lat
      }
    },
    // ------------进入编辑订单-------
    editWarehouse (row) {
      console.log(1);
      this.is_edit = true
      this.newWarehouseShowData = {
        name: row.name, //仓库名
        username: row.username,//仓库联系人姓名
        mobile: row.mobile, //仓库联系电话
        addaddress: [],
        address: row.address,//详细地址
        info: '暂无',//仓库介绍
        issm: 0,//是否支持上门收货
        smkm: 0,//上面收货距离km
        lng: 0,//坐标lng
        lat: 0,//坐标lat
        ckid: row.id
      }
      this.addWarehouseShow = true
    },
    //------------测试打印-------------
    test () {
      console.log(122);
    },
    //--------检测添加地址数据是否完整--
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.add_warehouse()
        } else {
          return false;
        }
      });
    },
    //------------获取地址信息-------------
    async getSite () {
      this.fullscreenLoading = true
      let res = await apiZHCN({
        all: 1
      })
      console.log(res.gjlist['CN']);

      this.allSite = common.transform(res.gjlist['CN'].children)
      this.fullscreenLoading = false

    },
    //------------显示添加仓库-------------
    show_add_warehouse () {
      this.addWarehouseShow = true
    },
    //------------添加仓库------------------
    async add_warehouse () {
      this.fullscreenLoading = true
      let res = await apiWarehouseOperation({
        pd: this.is_edit ? 'edit' : 'post',
        ckid: this.is_edit ? this.newWarehouseShowData.ckid : '',
        'addaddress[province]': this.newWarehouseShowData.addaddress[0],
        'addaddress[city]': this.newWarehouseShowData.addaddress[1],
        'addaddress[district]': this.newWarehouseShowData.addaddress[2],
        username: this.newWarehouseShowData.username,
        mobile: this.newWarehouseShowData.mobile,
        zipcode: '000000',
        address: this.newWarehouseShowData.address,
        name: this.newWarehouseShowData.name,
        info: this.newWarehouseShowData.info,
        issm: this.newWarehouseShowData.issm,
        smkm: this.newWarehouseShowData.smkm,
        lat: this.newWarehouseShowData.lat,
        lng: this.newWarehouseShowData.lng,
      })
      this.fullscreenLoading = false
      common.returnData(this, res.errno, res.message, () => {
        this.isAddWarehouseShow = false
        this.addWarehouseShow = false
        this.getListData()
      }, () => {

      })

    },

    //------------显示是否确认删除仓库---
    show_is_remove (row) {
      this.$confirm(`确定要删除${row.name}吗,此操作不可逆!`, '警告', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.remove_warehouse(row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //------------删除仓库------------------
    async remove_warehouse (ckid) {
      this.fullscreenLoading = true

      let res = await apiRemoveWarehouse({
        pd: 'del',
        ckid
      })
      this.fullscreenLoading = false
      common.returnData(this, res.errno, res.message, () => {
        this.getListData()
      }, () => {

      })
      console.log(res);
    },
    //------------编辑仓库信息--------------
    edit_warehouse (row) {

    },
    //------------获取仓库列表--------------
    async getListData () {
      this.fullscreenLoading = true

      let res = await apiWarehouse({
        pd: 'list'
      })
      this.fullscreenLoading = false

      if (res.errno == 0) {
        this.tableData = res.cklist
      } else {
        this.$message.error(res.message);
      }
    }
  },
  created () {
    this.getSite()
    this.getListData()
  }


}
</script>

<style lang="scss">
// 盒模块显示
/* .storeManagement {
  .storeManagement_top {
    background-color: pink;
  }
  .storeManagement_main {
    background-color: bisque;
  }
} */
.storeManagement {
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  // justify-content: space-between;
  align-items: center;
  .add_warehouse_dialog {
    .el-dialog {
      min-width: 700px;
    }
    // display: flex;
    // justify-content: center;
    .add_warehouse_form {
      margin-left: 20px;
      .el-input {
        width: 300px;
      }
    }
  }
  .storeManagement_top {
    display: flex;
    width: 100%;
    min-height: 200px;
    height: 20%;
    justify-content: flex-end;
    background-color: #fff;
    .add_warehouse {
      height: 100%;
      width: 200px;
      display: flex;
      background-color: #fff;
      // justify-content: center;
      align-items: center;
      .table_btn {
        min-width: 350px;
      }
      .el-button {
        width: 120px;
        height: 50px;
      }
    }
  }
  .storeManagement_main {
    display: flex;
    height: 50%;
    width: 100%;
    margin-top: 20px;
    min-height: 500px;
    justify-content: center;
    // align-items: center;
    justify-content: space-around;
    padding: 0 30px;
    background-color: #fff;
    box-sizing: border-box;
    .particulars {
      width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>